import { Controller } from '@hotwired/stimulus';

// LRPO-5559 — dirty-form reset for the First-scan-date modal.
//
// The modal (app/views/exhibitor/shared/_scan_date_modal.html.erb) is
// rendered once per page and re-shown in place by the navbar "Scan Dates"
// button (data-bs-toggle="modal") — it is the SAME persistent DOM node every
// time. Cancel only carries data-bs-dismiss="modal", which hides the modal
// but leaves the <input> holding its edited value, so reopening shows the
// stale unsaved change instead of the persisted date.
//
// This controller snapshots each input's persisted (server-rendered) value on
// connect and restores it on `hidden.bs.modal` — the Bootstrap event fired
// after Cancel, the close X, or Esc. The Save path is untouched: submitting
// navigates away and re-renders the modal from the new persisted value, so it
// never reaches this restore.
export default class extends Controller {
  static targets = ['input'];

  connect() {
    // Persisted values as rendered by the server. Captured once on connect;
    // they only change via a save, which triggers a full re-render (fresh
    // connect), so this snapshot stays authoritative for the modal's lifetime.
    this.snapshot = this.inputTargets.map((input) => input.value);

    this.restore = this.restore.bind(this);
    this.element.addEventListener('hidden.bs.modal', this.restore);
  }

  disconnect() {
    this.element.removeEventListener('hidden.bs.modal', this.restore);
  }

  // Discard any unsaved edits by resetting every input to its snapshot.
  restore() {
    this.inputTargets.forEach((input, i) => {
      input.value = this.snapshot[i];
    });
  }
}
